import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@material-ui/core'
import { useSelector } from 'react-redux'
import StepperFooter from 'components/SupporterOnboarding/StepperFooter'
import Welcome from 'components/SupporterOnboarding/Steps/Welcome'
import SetupTithing from 'components/SupporterOnboarding/Steps/SetupTithing'
import SetupRoundups from 'components/SupporterOnboarding/Steps/SetupRoundups'
import SetupFundingAccount from 'components/SupporterOnboarding/Steps/SetupFundingAccount'
import SetupTrackedCards from 'components/SupporterOnboarding/Steps/SetupTrackedCards'
import Finish from 'components/SupporterOnboarding/Steps/Finish'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { Redirect } from 'react-router-dom'
import { updateSupporterOnboardingActiveStepIndex } from 'actions/status'
import { updateUser } from 'actions/users'
import { completedOnboardingStep } from 'utils/mixpanel'

const ORDERED_STEP_COMPONENTS = [
  Welcome, SetupTithing, SetupRoundups, SetupFundingAccount, SetupTrackedCards, Finish
]

export default function SupporterOnboarding() {
  const activeStepIndex = useSelector(({ status: { supporterOnboardingActiveStepIndex } }) => supporterOnboardingActiveStepIndex)
  const dispatch = useDispatch()
  const ActiveStepComponent = ORDERED_STEP_COMPONENTS[activeStepIndex]
  const completedSupporterOnboarding = useCurrentUserProp('completedSupporterOnboarding')
  const userId = useCurrentUserProp('id')

  const [footerHeight, setFooterHeight] = useState(0)

  function scrollToTop() {
    window['scrollTo']({ top: 0, behavior: 'smooth' })
  }

  function completeStep(stepTitle) {
    completedOnboardingStep(stepTitle)
    const nextStepIndex = activeStepIndex + 1
    if(ORDERED_STEP_COMPONENTS[nextStepIndex]) {
      dispatch(updateSupporterOnboardingActiveStepIndex(nextStepIndex))
      scrollToTop()
    } else {
      dispatch(updateUser(userId, { completedSupporterOnboarding: true }))
    }
  }

  function goToPreviousStep() {
    dispatch(updateSupporterOnboardingActiveStepIndex(activeStepIndex - 1))
    scrollToTop()
  }

  if (completedSupporterOnboarding) {
    return <Redirect to='/home' />
  }

  const Footer = ({ ...propsFromCurrentStep }) => {
    return (
        <StepperFooter
          setFooterHeight={setFooterHeight}
          numberOfSteps={ORDERED_STEP_COMPONENTS.length}
          activeStepIndex={activeStepIndex}
          handleClickBack={goToPreviousStep}
          { ...propsFromCurrentStep }
        />
    )
  }

  return (
    <Box mt={2} mb={`${footerHeight}px`}>
      <ActiveStepComponent completeStep={completeStep} Footer={Footer} />
    </Box>
  )
}
